module.exports = __webpack_public_path__ + "static/media/reset.e0229cfe.mp3";